module.exports = __webpack_public_path__ + "img/20190523211325微信截图_20190523211717.a7f5d8d9.png";